import { BBCodeService } from '@dta/shared/services/bbcode/bbcode.service';

const BLOCK_ELEMENTS_SELECTOR = 'div, p, li, blockquote';
const NON_BREAKING_SPACE_PATTERN = / /g;

/**
 * Converts a raw comment body into the plain text the user actually sees in the comment bubble:
 * bbcode tags are resolved to their rendered content and the resulting markup is flattened.
 */
export function commentBodyToPlainText(body: string, bbCodeService: BBCodeService): string {
  if (!body) {
    return '';
  }

  // Keep html entities escaped so the parser below decodes them instead of treating them as markup
  const html = bbCodeService.process(
    {
      text: body,
      removeMisalignedTags: false,
      addInLineBreaks: false
    },
    false
  );

  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.body.querySelectorAll('br').forEach(lineBreak => lineBreak.replaceWith(doc.createTextNode('\n')));
  doc.body.querySelectorAll(BLOCK_ELEMENTS_SELECTOR).forEach(block => block.append(doc.createTextNode('\n')));

  return (doc.body.textContent ?? '').replace(NON_BREAKING_SPACE_PATTERN, ' ').trim();
}
